import { Component, OnInit, ElementRef, Input, Pipe } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-textblock',
  templateUrl: './textblock.component.html',
  styleUrls: ['./textblock.component.css']
})
export class TextblockComponent implements OnInit {
    public arrData = new Array<any>();
    public arrTable = new Array<any>();
    @Input() webpagedefinitionitemid: number;
    @Input() docid: number;
    @Input() webpagelayoutitemid: number;
    @Input() webpagethemeelementid: number;
    @Input() cache: boolean;

    constructor(public dataservice: DataService) { }

    ngOnInit() {
        this.dataservice.getElementData(this.webpagedefinitionitemid, this.docid, this.webpagelayoutitemid, this.webpagethemeelementid, this.cache, 'g2/textblock', (returndata: any) => {
            this.arrData = returndata;
            this.arrTable = returndata.Table;
        }, '');
    }
}

